import PropTypes from 'prop-types';

function MMHouseholdActive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <g clipPath="url(#clip0_386_11322)">
                <path
                    d="M12.705 14.2855C13.6078 13.7797 16.1156 12.6136 16.1156 12.6136C16.2358 12.5543 16.3747 12.5453 16.5017 12.5884C16.6287 12.6315 16.7333 12.7232 16.7927 12.8435L17.2942 13.8508C17.3537 13.9717 17.3629 14.1112 17.3198 14.2388C17.2767 14.3665 17.1849 14.4719 17.0643 14.5321C17.0643 14.5321 15.0205 15.648 13.6496 16.2624L12.705 14.2855Z"
                    fill="white"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4.79727 7.4268C4.5799 6.74822 4.57262 6.01979 4.77637 5.337C4.89857 4.80266 5.14506 4.30468 5.49582 3.88348C5.84658 3.46227 6.29173 3.12972 6.79512 2.91283C7.3694 2.62354 7.99687 2.45501 8.6388 2.41763C9.28074 2.38025 9.92353 2.47481 10.5275 2.69549C11.8775 3.29735 12.6633 4.78529 13.4532 6.95033C13.5668 6.51231 13.7864 6.10897 14.0927 5.77586C14.3058 5.54306 14.5862 5.38251 14.8949 5.31659C15.2035 5.25066 15.5251 5.28263 15.8147 5.40805C16.6506 5.75496 17.5534 6.66193 16.8011 8.38393C16.0488 10.1059 15.3842 11.1425 15.4678 11.3096L16.1365 12.597L11.7479 14.6533L4.80563 7.44352L4.79727 7.4268Z"
                    fill="#DFA455"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.0509 17.1738C14.0509 17.1738 13.3989 15.6316 12.5128 13.9305C11.3926 11.7529 10.5525 9.58786 10.0802 8.91495C9.5595 8.20086 8.87033 7.62655 8.07404 7.24311C7.5753 7.01669 7.02994 6.9119 6.48281 6.93733C5.93567 6.96276 5.40239 7.11769 4.9268 7.38939C4.34849 7.66981 3.83431 8.06661 3.41645 8.55494C2.9986 9.04328 2.68607 9.61263 2.49845 10.2273C2.17244 11.6609 2.89969 13.1865 4.15357 15.1049C3.73613 14.9318 3.28283 14.863 2.83282 14.9043C2.51846 14.9329 2.2209 15.059 1.98181 15.2652C1.74273 15.4713 1.5741 15.747 1.49953 16.0537C1.26129 16.9398 1.44101 18.1937 3.27168 18.6409C5.10234 19.0881 6.33115 19.1759 6.41474 19.3514C6.49833 19.527 7.04168 20.6596 7.04168 20.6596L14.0509 17.1738Z"
                    fill="#DFA455"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.98211 22.5778C7.98211 22.5778 11.4094 20.9435 12.726 20.2205C13.2818 19.9153 15.0038 19.092 15.0038 19.092C15.1237 19.0311 15.2146 18.9253 15.2568 18.7978C15.2991 18.6702 15.2893 18.5311 15.2295 18.4107L14.728 17.3992C14.6679 17.2797 14.5629 17.1889 14.436 17.1466C14.3091 17.1043 14.1707 17.114 14.0509 17.1735C14.0509 17.1735 10.5944 18.9624 9.40318 19.4807C8.45441 19.8986 7.02916 20.6593 7.02916 20.6593C6.90862 20.7195 6.81678 20.8249 6.77371 20.9525C6.73064 21.0802 6.73983 21.2197 6.79929 21.3406L7.30084 22.3479C7.361 22.4684 7.46641 22.5603 7.59406 22.6033C7.72171 22.6464 7.86122 22.6372 7.98211 22.5778V22.5778Z"
                    fill="#DFA455"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M8.62577 12.601C8.55054 12.4129 6.48582 10.3942 5.92993 9.67529Z" fill="white" />
                <path
                    d="M8.62577 12.601C8.55054 12.4129 6.48582 10.3942 5.92993 9.67529"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M8.00721 14.0221C8.00721 14.0221 5.87144 11.5143 4.62592 10.3398Z" fill="white" />
                <path
                    d="M8.00721 14.0221C8.00721 14.0221 5.87144 11.5143 4.62592 10.3398"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M8.44604 10.2314C7.79795 11.6019 7.07518 12.9358 6.28101 14.2271Z" fill="white" />
                <path
                    d="M8.44604 10.2314C7.79795 11.6019 7.07518 12.9358 6.28101 14.2271"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7.24232 9.4541C6.68941 10.7785 5.97936 12.0316 5.12744 13.1865Z" fill="white" />
                <path
                    d="M7.24232 9.4541C6.68941 10.7785 5.97936 12.0316 5.12744 13.1865"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.95062 14.4905L10.1512 16.0746C10.1512 16.0746 10.7447 19.5687 10.8534 21.6753C10.9036 22.6993 11.3633 25.742 11.3633 25.742C11.3633 25.742 12.287 27.3219 15.125 27.7023C16.6625 27.9695 18.2304 28.0159 19.781 27.8402C21.671 27.6637 23.5054 27.1048 25.1727 26.1976C26.97 25.3199 27.2876 23.9531 27.4757 23.6898C27.6094 23.5101 27.5885 21.3409 27.2249 18.9418C26.7234 15.7361 26.4684 11.9326 26.4684 11.9326"
                    fill="white"
                />
                <path
                    d="M9.95062 14.4905L10.1512 16.0746C10.1512 16.0746 10.7447 19.5687 10.8534 21.6753C10.9036 22.6993 11.3633 25.742 11.3633 25.742C11.3633 25.742 12.287 27.3219 15.125 27.7023C16.6625 27.9695 18.2304 28.0159 19.781 27.8402C21.671 27.6637 23.5054 27.1048 25.1727 26.1976C26.97 25.3199 27.2876 23.9531 27.4757 23.6898C27.6094 23.5101 27.5885 21.3409 27.2249 18.9418C26.7234 15.7361 26.4684 11.9326 26.4684 11.9326"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M26.4685 11.9325C26.5813 12.9356 25.7203 13.9512 24.2408 14.7746C22.7612 15.598 20.7466 16.0661 18.4854 16.4464C16.9598 16.6775 15.4066 16.6563 13.8879 16.3837C11.9653 16.0786 10.5149 15.4099 9.94652 14.4987C9.81007 14.2871 9.72425 14.0468 9.69574 13.7966C9.55781 12.5427 10.9204 11.3682 13.0394 10.4153C14.5135 9.78512 16.0806 9.39971 17.6788 9.27424C19.0684 9.13255 20.4688 9.13255 21.8584 9.27424C24.6545 9.5083 26.3055 10.5699 26.4685 11.9325Z"
                    fill="#F2EBD1"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M23.6305 15.0672C24.27 14.7997 20.8218 13.5291 17.3235 14.085C13.8252 14.6409 13.1648 16.2375 13.1648 16.2375C13.1648 16.2375 15.8063 16.5844 16.8094 16.5969C19.1597 16.5257 21.4749 16.0065 23.6305 15.0672V15.0672Z"
                    fill="white"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.3794 15.4915L7.43543 15.7086C7.06379 15.7501 6.79615 16.085 6.83764 16.4566L6.88725 16.9011C6.92874 17.2727 7.26365 17.5403 7.63529 17.4989L9.57927 17.2818C9.95091 17.2403 10.2185 16.9054 10.1771 16.5338L10.1274 16.0893C10.086 15.7177 9.75105 15.4501 9.3794 15.4915Z"
                    fill="#F2EBD1"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M29.2727 13.2694L27.3287 13.4864C26.957 13.5279 26.6894 13.8628 26.7309 14.2344L26.7805 14.6789C26.822 15.0505 27.1569 15.3182 27.5285 15.2767L29.4725 15.0597C29.8442 15.0182 30.1118 14.6833 30.0703 14.3116L30.0207 13.8672C29.9792 13.4955 29.6443 13.2279 29.2727 13.2694Z"
                    fill="#F2EBD1"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_386_11322">
                    <rect width="30" height="30" fill="white" transform="translate(0.780762 0.176758)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default MMHouseholdActive;

MMHouseholdActive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

MMHouseholdActive.defaultProps = {
    className: null,
    width: 28,
};
